<template>
  <crud
    mode="ServerSide"
    deleteMode="hard"
    :update-many-mode="false"
    :resolverType="resolverType"
    :list="list"
    :get="get"
    :create="create"
    :update="update"
    :remove="remove"
    :page-title="pageTitle"
    :fields-info="fieldsInfo"
    :details-title="$t('detailsTitle')"
    :custom-buttons="buttons"
    :item-elements="itemElements"
    ref="crud"
  >
  </crud>
</template>

<script>

import Crud from '@/utils/crud/components/Crud.vue'
import {
  mapActions,
} from 'vuex'

export default {
  data () {
    return {
      resolverType: 'dynamodb',
      list: 'listToDos',
      get: 'getToDo',
      create: 'createToDo',
      update: 'updateToDo',
      remove: 'deleteToDo',
      pageTitle: 'user.todos'
    }
  },
  computed: {
    itemElements () {
      return {
      }
    },
    buttons () {
      return [
      ]
    },
    fieldsInfo () {
      return [
        {
          text: this.$t('fields.id'),
          name: 'id',
          details: false,
        },
        // {
        //   type: 'date',
        //   column: 'updatedAt',
        //   text: this.$t('fields.updatedAt'),
        //   name: 'updatedAt',
        //   multiedit: false,
        // },
        // {
        //   type: 'select',
        //   column: 'status',
        //   text: this.$t('fields.status'),
        //   name: 'status',
        //   multiedit: false,
        // },
        {
          type: 'input',
          column: 'title',
          text: this.$t('fields.title'),
          name: 'title',
          multiedit: false,
        },
        {
          type: 'input',
          column: 'description',
          text: this.$t('fields.description'),
          name: 'description',
          multiedit: false,
        },
        // {
        //   type: 'input',
        //   column: 'editors',
        //   text: this.$t('fields.editors'),
        //   name: 'editors',
        //   multiedit: false,
        // },
        // {
        //   type: 'input',
        //   column: 'email',
        //   text: this.$t('fields.email'),
        //   name: 'email',
        //   multiedit: false,
        // },
      ]
    },
  },
  methods: {
  },
  components: {
    Crud,
  },
  i18n: {
    messages: {
      de: {
        detailsTitle: 'Benutzer',
        fields: {
          id: 'Id',
          user: 'Benutzername',
          email: 'E-mail',
          initialPassword: 'Initiales Passwort',
          userType: 'User Typ',
        },
        itemElements: {
          userPermissions: {
            title: 'Benutzerrechte',
            headers: {
              permission: 'Rechte',
            },
          },
        },
        buttons: {
          resetPassword: 'Passwort zurücksetzen',
        },
        passwordReseted: 'Passwort zurückgesetzt',
        passwordResetError: 'Fehler: Passwort konnte nicht zurückgesetzt werden',
      },
      en: {
        detailsTitle: 'User',
        fields: {
          id: 'Id',
          user: 'Username',
          email: 'E-mail',
          initialPassword: 'Initial password',
          userType: 'User type',
        },
        itemElements: {
          userPermissions: {
            title: 'User permissions',
            headers: {
              permission: 'Permission',
            },
          },
        },
        buttons: {
          resetPassword: 'Reset password',
        },
        passwordReseted: 'Password changed',
        passwordResetError: 'Error! Password change unsuccessful',
      },
    },
  },
}

</script>
